import { render } from "./Home.vue?vue&type=template&id=09a9fada&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=09a9fada&scoped=true&lang=css"

import exportComponent from "/Users/bilawal/Sites/bizrar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a9fada"]])

export default __exports__